import juice from 'juice';

export const buildEmailHtml = (rawHtml) => {
  const baseTemplate = `
    <div style="
      font-family: Arial, sans-serif;
      font-size: 14px;
      color: #111827;
      background-color: #ffffff;
      padding: 16px;
    ">
      ${rawHtml}
    </div>
  `;

  return juice(baseTemplate, {
    removeStyleTags: true,
    preserveMediaQueries: false,
  });
};
